<div class="navbar-wrap">
  <ng-content></ng-content>
</div>
